import gql from 'graphql-tag';

export const SIMILAR_PROPERTIES_FRAGMENT = gql`
    fragment SIMILAR_PROPERTIES_FRAGMENT on ListingData {
        analyticsTaxonomy {
            location
            listingsCategory
        }
        section
    }
`;

export const SIMILAR_PROPERTIES_CARD = gql`
    fragment SIMILAR_PROPERTIES_CARD on Listing {
        listingId
        title
        branch {
            name
            logoUrl
        }
        features {
            content
            iconId
        }
        image {
            src
            caption
            responsiveImgList {
                width
                src
            }
        }
        flag
        priceTitle
        price
        address
        tags {
            content
        }
        listingUris {
            detail
        }
    }
`;

export const SIMILAR_PROPERTIES_QUERY = gql`
    query getListingDetails($listingId: Int!, $similarPropertiesLimit: Int) {
        listing(id: $listingId) {
            similarListings(first: $similarPropertiesLimit) {
                ...SIMILAR_PROPERTIES_CARD
            }
        }
    }
    ${SIMILAR_PROPERTIES_CARD}
`;
